import { B2Button } from "@hdb/biome-2";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router";
import "./error.scss";
import Cookies from "universal-cookie";

const LoginErrorComponent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;
  const [hasReloaded, setHasReloaded] = useState(false);

  function goToLogin() {
    navigate("/login");
  }

  const clearSiteData = () => {
    const cookies = new Cookies();

    // Clear all cookies for current domain
    const allCookies = cookies.getAll();
    Object.keys(allCookies).forEach((name) => {
      cookies.remove(name, { path: "/" });
      cookies.remove(name, { path: "/", domain: window.location.hostname });
    });

    // Clear storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear cookies for parent domain
    try {
      const parentDomain = window.location.hostname
        .split(".")
        .slice(-2)
        .join(".");
      Object.keys(allCookies).forEach((name) => {
        cookies.remove(name, { path: "/", domain: parentDomain });
      });
    } catch (e) {
      console.warn("Couldn't clear parent domain cookies", e);
    }
  };

  useEffect(() => {
    if (pathname === "/login-error" && !hasReloaded) {
      const urlParams = new URLSearchParams(search);
      const isReloaded = urlParams.get("reloaded") === "true";

      if (!isReloaded) {
        clearSiteData();

        const newUrl = `${pathname}?reloaded=true`;
        window.location.replace(newUrl);
      } else {
        setHasReloaded(true);
      }
    }
  }, [pathname, search, hasReloaded]);

  return (
    <>
      <Helmet>
        <title>Login Error | SLP</title>
      </Helmet>
      <div className="forbidden-container">
        <h1 className="forbidden-text">Login Error</h1>
        <p className="forbidden-description">
          Log in failed. Please contact with Administrator
        </p>

        <B2Button variant="primary" onClick={goToLogin}>
          Go To Login
        </B2Button>
      </div>
    </>
  );
};

export default LoginErrorComponent;
